import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { ButtonWithIcon } from '@els/els-react--button';

import { DRAWER_VIEW_ASSISTANT, DRAWER_VIEW_FILTERS } from './constants';

const NAV_ITEMS = {
  [DRAWER_VIEW_ASSISTANT]: {
    label: 'Assistant',
    sprite: 'AI',
    testId: 'drawer-nav-assistant',
  },
  [DRAWER_VIEW_FILTERS]: {
    label: 'Filters',
    sprite: 'Filter',
    testId: 'drawer-nav-filters',
  },
};

export default function ResultsFiltersRail({
  activeView,
  assistantEligible,
  hasAssistantUpdate,
  isOpen,
  onSelectView,
  onToggle,
  panelId,
  toggleRef,
}) {
  const railLabel = assistantEligible ? 'Assistant and filters' : 'Filters';
  const controlledPanelLabel = assistantEligible ? 'assistant and filters' : 'filters';
  const toggleLabel = `${isOpen ? 'Collapse' : 'Expand'} ${controlledPanelLabel} panel`;
  const views = assistantEligible ? [DRAWER_VIEW_ASSISTANT, DRAWER_VIEW_FILTERS] : [DRAWER_VIEW_FILTERS];

  return (
    <div className="rx-results-filters-sidebar" data-e2e="drawer-component" role="group" aria-label={railLabel}>
      <div className="rx-results-filters-sidebar__controls">
        <ButtonWithIcon
          ref={toggleRef}
          data-e2e="drawer-toggle-button"
          type="borderless"
          sprite={isOpen ? 'NavCollapse' : 'NavExpand'}
          onClick={onToggle}
          iconOnly
          size="small"
          className="rx-results-filters-sidebar__toggle"
          aria-expanded={isOpen}
          aria-controls={panelId}>
          {toggleLabel}
        </ButtonWithIcon>
      </div>
      <div className="rx-results-filters-sidebar__items">
        {views.map((view) => {
          const { label, sprite, testId } = NAV_ITEMS[view];
          const isActive = isOpen && activeView === view;

          return (
            <ButtonWithIcon
              key={view}
              data-e2e={testId}
              type="borderless"
              sprite={sprite}
              layout="vertical"
              size="small"
              active={isActive}
              className={classnames('rx-results-filters-sidebar__item', {
                'rx-results-filters-sidebar__item--active': isActive,
              })}
              aria-pressed={isActive}
              aria-expanded={isOpen && isActive}
              aria-controls={panelId}
              onClick={(event) => onSelectView(view, event.currentTarget)}>
              {label}
              {view === DRAWER_VIEW_ASSISTANT && hasAssistantUpdate && (
                <span className="rx-results-filters-sidebar__badge" aria-hidden="true" data-testid="assistant-filter-applied-dot" />
              )}
            </ButtonWithIcon>
          );
        })}
      </div>
    </div>
  );
}

ResultsFiltersRail.propTypes = {
  activeView: PropTypes.oneOf([DRAWER_VIEW_ASSISTANT, DRAWER_VIEW_FILTERS]).isRequired,
  assistantEligible: PropTypes.bool,
  hasAssistantUpdate: PropTypes.bool,
  isOpen: PropTypes.bool,
  onSelectView: PropTypes.func.isRequired,
  onToggle: PropTypes.func.isRequired,
  panelId: PropTypes.string.isRequired,
  toggleRef: PropTypes.shape({ current: PropTypes.object }),
};
